export default process.env.NODE_ENV === 'production'
  ? 'https://analytics.verdedata.ro'
  : 'http://localhost:3333'
// export default process.env.NODE_ENV === 'production' ? 'https://analytics.verdedata.ro' : 'https://analytics.verdedata.ro'
// export default process.env.NODE_ENV === 'production' ? 'https://analytics.verdedata.ro' : 'http://10.194.250.173'
